import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> Mobile - (Android/ios)</li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>Mobile Application Security Testing</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  Mobile applications have become a vital channel for businesses
                  to engage customers, process transactions, and deliver digital
                  services. However, with their growing use comes increasing
                  risk. Mobile apps are often targeted by attackers looking to
                  exploit vulnerabilities in code, insecure APIs, or weak device
                  configurations. <b>Mobile Application Security Testing (MAST)</b>{" "}
                  simulates real-world attacks on mobile apps to uncover
                  vulnerabilities before they can be exploited — protecting
                  sensitive data, financial transactions, and business
                  integrity.
                </p>
              </div>
              {/* headings */}

              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  {
                    icon: "fa-arrows-down-to-people",
                    title: "High User Dependency",
                    desc: "Millions of customers rely on mobile apps daily, making them an attractive attack target.",
                  },
                  {
                    icon: "fa-database",
                    title: "Data Sensitivity",
                    desc: "Mobile apps often handle personal, financial, and corporate data that must remain secure.",
                  },
                  {
                    icon: "fa-shield-halved",
                    title: "Evolving Threats",
                    desc: "Mobile-specific risks such as insecure storage, API abuse, reverse engineering, and malware injection are increasing.",
                  },
                  {
                    icon: "fa-table",
                    title: "Regulatory Compliance",
                    desc: "Standards like PCI DSS, GDPR, HIPAA, and ISO 27001 require strong data protection within mobile apps.",
                  },
                  {
                    icon: "fa-business-time",
                    title: "Brand Reputation",
                    desc: "A single mobile breach can erode customer trust and impact long-term business growth.",
                  },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/*-------- TAB AND PILL SEC ----------- */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "methodology", label: "Methodology" },
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content">
                    {/* Methodology */}
                    <div
                      className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>
                        Our MAST methodology aligns with global standards such as OWASP Mobile Top 10 and SANS 25, combining automated scans with deep manual testing.
                      </p>
                      <ul>
                        <li><b>Information Gathering :-</b> Understanding the app’s architecture, permissions, and attack surface.</li>
                        <li><b>Static Analysis (SAST) :-</b> Reviewing code (where available) for security flaws and weaknesses.</li>
                        <li><b>Dynamic Analysis (DAST) :-</b> Testing the app in a running state to simulate real-world attacks.</li>
                        <li><b>API Security Testing :-</b> Assessing backend services and communication between app and server.</li>
                        <li><b>Business Logic Testing :-</b> Identifying flaws in workflows that attackers can exploit.</li>
                        <li><b>Exploitation & Validation :-</b> Safely confirming vulnerabilities without disrupting service.</li>
                        <li><b>Reporting & Remediation :-</b> Delivering detailed findings with actionable guidance.</li>
                      </ul>
                    </div>

                    {/* Key Benefits */}
                    <div
                      className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <ul>
                        <li>Identify vulnerabilities unique to mobile platforms (iOS & Android).</li>
                        <li>Protect sensitive customer and financial data from mobile-specific threats.</li>
                        <li>Strengthen customer trust and brand reputation.</li>
                        <li>Meet compliance requirements for data protection and security.</li>
                        <li>Prevent reverse engineering, tampering, and API abuse.</li>
                        <li>Gain actionable insights and remediation support.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div
                      className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>At the conclusion of our Mobile Application Security Testing engagement, you will receive:</p>
                      <ul>
                        <li><b>Comprehensive Security Report :-</b> Detailed findings with technical analysis and business impact.</li>
                        <li><b>Remediation Roadmap :-</b> Clear and prioritized recommendations for developers.</li>
                        <li><b>Executive Summary :-</b> Non-technical overview for stakeholders and leadership.</li>
                        <li><b>Re-Testing & Validation :-</b> Assurance that all identified vulnerabilities have been fixed.</li>
                        <li><b>Continuous Security Advisory :-</b> Strategic support to keep mobile apps secure as they evolve.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/*---------- TAB AND PILL SEC ---------- */}

              {/* ------- OUR APPROACH SEC ------ */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach</h3>
                  <p>
                    When it comes to mobile app security, generic scans aren’t enough. Our approach ensures complete and business-focused protection:
                  </p>
                  <ul>
                    <li><b>Expert-Led Assessments :-</b> Certified testers with deep expertise in Android and iOS environments.</li>
                    <li><b>Beyond Code Reviews :-</b> We test how your app behaves in real-world attack scenarios, not just on paper.</li>
                    <li><b>API & Backend Coverage :-</b> We secure not just the app, but the entire ecosystem it connects to.</li>
                    <li><b>Device-Level Security :-</b> Testing for risks like insecure storage, improper permissions, and jailbreak/root detection bypass.</li>
                    <li><b>Compliance-Driven :-</b> Aligned with OWASP, PCI DSS, HIPAA, and GDPR standards to meet regulatory needs.</li>
                    <li><b>Partnership Mindset :-</b> From testing to remediation and validation, we work with your team every step of the way.</li>
                  </ul>
                </div>
              </div>
              {/* ------- OUR APPROACH SEC ------ */}
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
